export const IconTicket = ({ ...props }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width="1em"
      height="1em"
      {...props}
    >
      <mask
        id="IconTicket_svg__a"
        width={24}
        height={24}
        x={0}
        y={0}
        maskUnits="userSpaceOnUse"
        style={{
          maskType: "alpha",
        }}
      >
        <path d="M0 0h24v24H0z" />
      </mask>
      <g mask="url(#IconTicket_svg__a)">
        <path d="M4 20q-.824 0-1.412-.587A1.93 1.93 0 0 1 2 18v-3.375q0-.275.175-.475a.76.76 0 0 1 .45-.25q.6-.2.987-.725A1.93 1.93 0 0 0 4 12q0-.65-.388-1.175a2 2 0 0 0-.987-.725.76.76 0 0 1-.45-.25A.7.7 0 0 1 2 9.375V6q0-.824.587-1.412A1.93 1.93 0 0 1 4 4h16q.824 0 1.413.588Q22 5.175 22 6v3.375a.7.7 0 0 1-.175.475.76.76 0 0 1-.45.25q-.6.2-.988.725Q20 11.35 20 12t.387 1.175.988.725a.76.76 0 0 1 .45.25.7.7 0 0 1 .175.475V18q0 .824-.587 1.413A1.93 1.93 0 0 1 20 20zm0-2h16v-2.55a4.1 4.1 0 0 1-1.462-1.462A3.85 3.85 0 0 1 18 12q0-1.076.538-1.988A4.1 4.1 0 0 1 20 8.55V6H4v2.55a4.1 4.1 0 0 1 1.463 1.462Q6 10.926 6 12q0 1.076-.537 1.988A4.1 4.1 0 0 1 4 15.45zm8-1q.424 0 .713-.288A.97.97 0 0 0 13 16a.97.97 0 0 0-.287-.713A.97.97 0 0 0 12 15a.97.97 0 0 0-.713.287A.97.97 0 0 0 11 16q0 .424.287.712.288.288.713.288m0-4q.424 0 .713-.287A.97.97 0 0 0 13 12a.97.97 0 0 0-.287-.713A.97.97 0 0 0 12 11a.97.97 0 0 0-.713.287A.97.97 0 0 0 11 12q0 .424.287.713.288.287.713.287m0-4q.424 0 .713-.287A.97.97 0 0 0 13 8a.97.97 0 0 0-.287-.713A.97.97 0 0 0 12 7a.97.97 0 0 0-.713.287A.97.97 0 0 0 11 8q0 .424.287.713Q11.576 9 12 9" />
      </g>
    </svg>
  );
};
